import Base from './Base';

class Meta extends Base {
    byUrl(url) {
        const encoded = encodeURIComponent(url || '');

        return this.apiClient.get({
            requestURL : `api/meta/${encoded}`
        });
    }
}

export default Meta;
